import seriesDataUpdate from "./seriesDataUpdate";

const MovingAverageCalculation = (movingAverageRange, pollDate, partyDataV2, type, party) => {
    partyDataV2.MAIndex += 1;
    partyDataV2.MASum = 0;
    
    if(partyDataV2.MAIndex < movingAverageRange) {
        for(let i=0; i<partyDataV2.MAIndex; i++) {
            partyDataV2.MASum += partyDataV2.percentages[i];
        }
        partyDataV2.MAAvg = partyDataV2.MASum / partyDataV2.MAIndex;
    }
    else {
        for(let i=0; i<movingAverageRange; i++) {
            partyDataV2.MASum += partyDataV2.percentages[partyDataV2.MAIndex - i - 1];
        }
        partyDataV2.MAAvg = partyDataV2.MASum / movingAverageRange;
    }
    
    seriesDataUpdate(type, 'spline', party, [pollDate, partyDataV2.MAAvg]);
}
export default MovingAverageCalculation;